import { render, staticRenderFns } from "./studentPaper.vue?vue&type=template&id=1dfae52b&scoped=true&"
import script from "./studentPaper.vue?vue&type=script&lang=js&"
export * from "./studentPaper.vue?vue&type=script&lang=js&"
import style0 from "./studentPaper.vue?vue&type=style&index=0&id=1dfae52b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfae52b",
  null
  
)

export default component.exports